import { useEffect, useRef } from 'react';
import { idCard } from '@/assets/images/emojis';
import { Button } from '@/ui/components';
import { Icon } from '@/ui/icons/Icon';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import styles from './AddBankCardPage.module.scss';
import { useAddBankCardRedirect } from '../../hooks/useAddBankCardRedirect';

// Opened by a link: goes on to the card partner's form. This screen only
// shows when that could not start.
export function AddBankCardPage() {
  const { startAddBankCard, isRedirecting, error } = useAddBankCardRedirect();
  const hasStarted = useRef(false);

  useEffect(() => {
    if (!hasStarted.current) {
      hasStarted.current = true;
      void startAddBankCard();
    }
  }, []);

  if (!error) {
    return <PageLoader />;
  }

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        {/* Header Section */}
        <div className={styles.header}>
          <div className={styles.emojiContainer}>
            <img src={idCard} alt="ID Card" className={styles.emoji} />
          </div>
          <div className={styles.titleSection}>
            <h1 className={styles.title}>
              Adaugă cardul pe care vrei să primești banii
            </h1>
            <div className={styles.description}>
              <p>
                Urmează să fii redirecționat spre forma de plată a partenerilor
                noștri pentru a completa datele cardului.
              </p>
              <p>
                Asigură-te că ai cel puțin 1 leu în cont pentru a valida cardul
                prin 3D Secure.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Button Section */}
      <div className={styles.bottomSection}>
        <Button
          trackingId="add_bank_card"
          onClick={startAddBankCard}
          className={styles.continueButton}
          text="Continuă"
          rightIcon={<Icon name="arrow-right" />}
          loading={isRedirecting}
        />
      </div>
    </div>
  );
}
